import { render, staticRenderFns } from "./ContactDeBaseNew.vue?vue&type=template&id=23d2ee5b"
import script from "./ContactDeBaseNew.vue?vue&type=script&lang=js"
export * from "./ContactDeBaseNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports